import React from "react";
import { IPickerItemProps, TagItem, nuOrderTheme as theme } from "@nuorder/components";
import { FOLDERS } from "constants/integration/folders";

export const AssortmentPickerTag: React.FunctionComponent<IPickerItemProps<any>> = ({ item, ...rest }) => {
    const styles = {
        root: [
            item.showErrorStyle && {
                backgroundColor: theme.palette.errorLight,
                "&:hover": {
                    backgroundColor: theme.palette.errorLight,
                },
            },
        ],
        close: [
            {
                "& svg": {
                    height: 16,
                    width: 16,
                    fill: theme.palette.greyDark,
                },
                "&:hover": {
                    svg: {
                        fill: theme.palette.black,
                    },
                },
            },
            item.showErrorStyle && {
                "&:hover": {
                    backgroundColor: `${theme.palette.errorLight} !important`,
                },
            },
        ],
    };
    return (
        <div
            key={item.key}
            data-test={FOLDERS.CREATE_ROLLUP_ASSORTMENT_DIALOG.ASSORTMENT_TAG}
            data-tag-id={item.key}
            data-deleted={item.isDeleted}
        >
            <TagItem item={item} {...rest} key={item.key} styles={styles}>
                {item.name}
            </TagItem>
        </div>
    );
};
